import { render, staticRenderFns } from "./beamWarpingAdd.vue?vue&type=template&id=974fda10&scoped=true&"
import script from "./beamWarpingAdd.vue?vue&type=script&lang=js&"
export * from "./beamWarpingAdd.vue?vue&type=script&lang=js&"
import style0 from "./beamWarpingAdd.vue?vue&type=style&index=0&id=974fda10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974fda10",
  null
  
)

export default component.exports